import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputText from "../../helpers/InputText";
import InputUploader from "../../helpers/InputUploader";


function CardImport(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


       const [errTab, setErrTab] = useState([]);  //z info od serwera..
 
       const [row, setRowX] = useState({                
                opis: "",               
        });
        var tmpRow = row;



        const [checked, setChecked] = useState(false);
        const handleChange = () => {
            setChecked(!checked);
          };


        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        const valChangeListener = (filedName, val, correct, msg) => {         
            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
         
          
            tmpRow[filedName] = val;
            tmpRow[filedName+"_valid"] = correct;         
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
            //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
        } 




    const completeUpload = (fileName, crypt) => {
        console.log("completeUpload " + fileName + " " + crypt);
        goParse(crypt); 
    }


        const goParse = (cr) => {
 
 
        var req = {
            crypt: cr,
            opis: row.opis, 
        }


        props.mainView.setProgress(-2);

    
        fetch( Config.master + '/rest_v1_access,import_cards', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                
                           props.mainView.showDialog( "Sukces",  "Odbicia kart zostały zaimportowane", "ok" , null); 
                           props.onBack();

                        }if(res.status == 'FILETYPE') {
                                
                            props.mainView.showDialog( "Error",  "Plik nie został rozpoznany" , "ok" , null);                               

                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }


        

         
        const goNextNew = () => {
            console.log("goNext");
            
        }
    
      






      return (
                 <div className="view_content">

                        <h1><PlTitle userData={props.userData} /> / Nowa karta</h1>
                    
                        
                        <form className="eForm bg_center">

                                     


                                    <div className="form_tab">

                                     
 
                                            <div className="form_split"></div>
                                       
                                            <div className="form_control">
                                                <div className="fieldName">Opis operacji, np. import z Roger</div>
                                                <InputText   userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Opis:"} className=' w300 ' req='0' firstUp="1" />
                                            </div>

                                            {
                                                row.opis.length > 2 &&
                                                <Fragment>


                                                <div className="form_split"></div>

                                                        <div className="form_control">                                           
                                                        <InputUploader   userData={props.userData}  typ="karty" typId={"-1"} remove="0" completeUpload={completeUpload} title={ "* -kliknij TUTAJ i wybierz plik .csv -" } max_files="1" ext=".csv" />                                                                                
                                                        </div>

                                                        <p>
                                                            *Plik csv (rozdzielony ';')  powinien zawierać kolumny o nazwach: TIME, CARD, TYPE.
                                                            <ul>
                                                                <li>TIME - godzina zdarzenia np. 2025-01-01 12:10</li>
                                                                <li>CARD - identyfikator karty tzw. CARD Id lub unikalny opis karty</li>
                                                                <li>TYPE - typ operacji, dopuszczalne wartości: wejście, wyjście, IN, OUT, I, O lub puste - typ zostanie określony wg. godziny operacji.</li>
                                                            </ul>  
                                                        </p>

                                                </Fragment>
                                            }

                                    </div>

   

                                    <div className="form_split"></div>

                                    <div className="form_btn">
                                            
                                            <div className="btn" onClick={props.onBack}   > anuluj</div>
                                    </div>

                        </form>

                </div>
        )

}

export default CardImport;